<template>
  <div>
    <h5 class="card-title">
      <i class="fas fa-bell"></i>
      Denúncias Novas para Você
    </h5>

    <div v-if="loading" class="text-center">
      <b-spinner small></b-spinner>
      <span class="ml-2">Carregando...</span>
    </div>

    <div v-else-if="totalUnviewed === 0" class="text-muted text-center">
      <i class="fas fa-check-circle"></i>
      Nenhuma denúncia nova encontrada
    </div>

    <div v-else>
      <div class="mb-3">
        <b-badge variant="info" class="mr-2">
          Total: {{ totalUnviewed }}
        </b-badge>
        <small class="text-muted">
          {{ totalUnviewed === 1 ? "denúncia nova" : "denúncias novas" }}
          aguardando sua visualização
        </small>
      </div>

      <div class="notifications-list-container">
        <div class="notifications-header">
          <div class="row-content">
            <div class="protocol-section header-label">PROTOCOLO</div>
            <div class="date-section header-label">DATA DE CRIAÇÃO</div>
            <div class="status-section header-label">STATUS</div>
            <div class="actions-section header-label">AÇÃO</div>
          </div>
        </div>

        <div class="notifications-scroll" @scroll="handleScroll">
          <div class="notifications-list">
            <div
              v-for="complaint in complaints"
              :key="complaint._id"
              class="notification-row"
              @click="openComplaint(complaint)"
            >
              <div class="row-content">
                <div class="protocol-section">
                  <strong class="protocol-link">{{
                    complaint.protocol
                  }}</strong>
                </div>

                <div class="date-section">
                  <span class="date-text">{{
                    formatDate(complaint.createdAt)
                  }}</span>
                </div>

                <div class="status-section">
                  <b-badge :variant="getStatusVariant(complaint.status)">
                    {{ getStatusText(complaint.status) }}
                  </b-badge>
                </div>

                <div class="actions-section">
                  <i class="fas fa-external-link-alt action-icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUnviewedComplaintsForUser } from "../../../../api/charts";

export default {
  name: "UnviewedComplaintsForUser",
  props: {
    companyId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      allComplaints: [],
      totalUnviewed: 0,
      loading: true,
      limit: 15,
    };
  },
  computed: {
    complaints() {
      return this.allComplaints.slice(0, this.limit);
    },
  },
  watch: {
    companyId() {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        this.limit = 15;
        const response = await getUnviewedComplaintsForUser(this.companyId);
        this.allComplaints = response.data.complaints;
        this.totalUnviewed = response.data.total;
      } catch (error) {
        console.error("Erro ao carregar denúncias não visualizadas:", error);
        this.$bvToast.toast("Erro ao carregar denúncias não visualizadas", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },
    openComplaint(complaint) {
      this.$router.push(`/denuncias/${complaint._id}`);
    },
    handleScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (this.limit < this.allComplaints.length) {
          this.limit += 15;
        }
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("pt-BR");
    },
    getStatusText(status) {
      const statusMap = {
        0: "Nova",
        1: "Em Processamento",
        2: "Concluída",
      };
      return statusMap[status] || "Desconhecido";
    },
    getStatusVariant(status) {
      const variantMap = {
        0: "primary",
        1: "warning",
        2: "success",
      };
      return variantMap[status] || "secondary";
    },
  },
};
</script>

<style scoped>
.card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.card-title i {
  color: #4299e1;
}

.notifications-list-container {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.notifications-header {
  background-color: #f7fafc;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.75rem 1rem;
}

.notifications-scroll {
  max-height: 460px;
  overflow-y: auto;
}

.notifications-list {
  background: white;
}

.notification-row {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.notification-row:last-child {
  border-bottom: none;
}

.notification-row:hover {
  background-color: #f7fafc;
}

.row-content {
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 0.5fr;
  gap: 1rem;
  align-items: center;
}

.protocol-section,
.date-section,
.status-section,
.actions-section {
  display: flex;
  align-items: center;
}

.header-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.protocol-link {
  color: #4299e1;
  font-size: 0.9rem;
}

.date-text {
  font-size: 0.85rem;
  color: #4a5568;
}

.action-icon {
  color: #4299e1;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .row-content {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .header-label {
    display: none;
  }
}
</style>
